import { each } from 'lodash'

export class Sheet {
  grade: number = 0
  name: string = ""
  room_name: string = ""
  curriculum_id: number = 0
  subject_name: string = ""
  sheet_type: number
  exec_date: string
  page_count:number
  is_digital_paper: boolean

  constructor(sheet: any){
    this.grade = sheet.grade;
    this.name = sheet.name;
    this.room_name = sheet.room_name;
    this.curriculum_id = sheet.curriculum_id;
    this.subject_name = sheet.subject_name;
    this.sheet_type = sheet.sheet_type;
    this.exec_date = sheet.exec_date;
    this.page_count = sheet.page_count;
    this.is_digital_paper = sheet.is_digital_paper;
  }
}

export class Examinee {
  id: number
  sheet_id: number
  room_name: string
  student_no: number
  student_no_character: string
  student_name: string
  score: string
  result_image_created: boolean

  constructor(examinee: any){
    this.id = examinee.id;
    this.sheet_id = examinee.sheet_id;
    this.room_name = examinee.room_name;
    this.student_no = examinee.student_no;
    this.student_no_character = examinee.student_no_character == null ? "-" : examinee.student_no_character;
    this.student_name = examinee.student_name == null ? "-" : examinee.student_name;
    this.result_image_created = examinee.result_image_created;
  }
}

export class TotalResult {
  allot: number
  score: number
  all_rank: string
  room_rank: string
  all_examinee_count: number
  room_examinee_count: number
  avg_score: number

  constructor(x: any){
    this.allot = x.allot;
    this.score = x.score;
    this.all_rank = x.all_rank;
    this.room_rank = x.room_rank;
    this.all_examinee_count = x.all_examinee_count;
    this.room_examinee_count = x.room_examinee_count;
    this.avg_score = x.avg_score;
  }
}

export class Part1Result {
  part1: string
  score: number
  allot: number
  all_rank: number
  room_rank: number
  all_examinee_count: number
  room_examinee_count: number
  all_avg_score: number
  room_avg_score: number
  score_rate: number
  sort_no: number

  constructor(x: any){
    this.part1 = x.part1;
    this.score = x.score;
    this.allot = x.allot;
    this.all_rank = x.all_rank;
    this.room_rank = x.room_rank;
    this.all_examinee_count = x.all_examinee_count;
    this.room_examinee_count = x.room_examinee_count;
    this.all_avg_score = x.all_avg_score;
    this.room_avg_score = x.room_avg_score;
    this.score_rate = x.score_rate;
    this.sort_no = x.sort_no;
  }
}

export class FieldResult {
  part1: string
  part2: string
  part3: string
  score: number
  allot: number
  correct_state: string
  score_rate: number
  sort_no: number

  constructor(x: any){
    this.part1 = x.part1;
    this.part2 = x.part2;
    this.part3 = x.part3;
    this.score = x.score;
    this.allot = x.allot;
    this.correct_state = x.correct_state;
    this.score_rate = x.score_rate;
    this.sort_no = x.sort_no;
  }
}

export interface SchoolSetting {
  id: number
  section: string
  key: string
  value: string
  value_type: string
  label: string
}